
import s from './subclasse/state'
import * as a from './subclasse/actions'
import * as m from './subclasse/mutations'
import * as g from './subclasse/getters'

export const state = s
export const actions = {...a}
export const mutations = {...m}
export const getters = {...g}
